<template>
    <modal ref="modal" :modal-backdrop="true">
        <template #body>
            <div class="text-center">
                <div class="text-gray-700 text-lg">Sair</div>
                <div class="mt-4 mb-4">Deseja realmente sair?</div>
                <button type="button" class="btn-primary-invert font-normal" @click.prevent="close">Não</button>
                <button type="button" class="btn-primary font-normal ml-1" @click.prevent="confirm">Sim</button>
            </div>
        </template>
    </modal>
</template>
<script>
import { ref } from 'vue';
import Modal from '@/Shared/Modal/Modal'

export default {
    components: {
        Modal,
    },
    setup(props, context) {
        const url = ref(props.url);
        const item = ref(props.item);

        const modal = ref(null);
        
        const openModalLogout = (i, u) => {
            url.value = u;
            item.value = i;
            modal.value.showModal = true;
        }

        const closeModalLogout = () => {
            modal.value.showModal = false;
        }

        return {
            openModalLogout,
            closeModalLogout,
            modal,
            item,
            url
        }
    },
    methods: {
        confirm() {
            this.close();
            this.$inertia.visit('/logout');
        },
        open() {
            this.$refs.modal.showModal = true;
        },
        close() {
            this.$refs.modal.showModal = false;
        }
    },
}
</script>
<style>
    
</style>